var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditeProfileBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edite_profile_blue",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1471",
    "data-name": "Group 1471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3694",
    "data-name": "Path 3694",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1473",
    "data-name": "Group 1473",
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1472",
    "data-name": "Group 1472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3695",
    "data-name": "Path 3695",
    d: "M10.67,13.02c-.22-.01-.44-.02-.67-.02a12.876,12.876,0,0,0-6.61,1.82A2.922,2.922,0,0,0,2,17.35V19a1,1,0,0,0,1,1h8.26A6.963,6.963,0,0,1,10,16,7.072,7.072,0,0,1,10.67,13.02Z",
    transform: "translate(-2 -4)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(4)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696",
    "data-name": "Path 3696",
    d: "M20.75,16a4.338,4.338,0,0,0-.06-.63l.84-.73a.5.5,0,0,0,.1-.63l-.59-1.02a.488.488,0,0,0-.59-.22l-1.06.36a3.647,3.647,0,0,0-1.08-.63l-.22-1.09a.5.5,0,0,0-.49-.4H16.42a.5.5,0,0,0-.49.4l-.22,1.09a3.647,3.647,0,0,0-1.08.63l-1.06-.36a.5.5,0,0,0-.59.22l-.59,1.02a.5.5,0,0,0,.1.63l.84.73a4.338,4.338,0,0,0-.06.63,4.338,4.338,0,0,0,.06.63l-.84.73a.5.5,0,0,0-.1.63l.59,1.02a.488.488,0,0,0,.59.22l1.06-.36a3.647,3.647,0,0,0,1.08.63l.22,1.09a.5.5,0,0,0,.49.4H17.6a.5.5,0,0,0,.49-.4l.22-1.09a3.647,3.647,0,0,0,1.08-.63l1.06.36a.5.5,0,0,0,.59-.22l.59-1.02a.5.5,0,0,0-.1-.63l-.84-.73A4.338,4.338,0,0,0,20.75,16ZM17,18a2,2,0,1,1,2-2A2.006,2.006,0,0,1,17,18Z",
    transform: "translate(-2 -4)",
    fill: "#374955"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditeProfileBlue);
export default __webpack_public_path__ + "static/media/edite_profile_blue.db46c84a1564d2b46fbc6e15a0ab9439.svg";
export { ForwardRef as ReactComponent };